import React, { useState, useEffect } from "react";

import DetailedCard from "../../Claims/DetailedCard";
import CollectionsContent from "./CollectionsContent";
import TransportAlert from "../../VehicleCard/TransportAlert";
import { useAuthZeroContext } from "../../context/AuthZeroContext";

import { getLocationService } from "../../../apiService";

import type { ISundryMessages } from "../../VehicleCard/TransportModalSundryMessages";
import OutstandingChargesMessage from "./OutstandingChargesMessage";

export interface ICollectionAddress {
  addressLine1: string;
  addressLine2: string;
  companyName: string;
  country: string;
  countyState: string;
  postcode: string;
  townCity: string;
}

interface CollectionsProps {
  closeTransportModal: () => void;
  bookCollectionsOnClickHandler: () => void;
  location: string;
  sundryMessages: ISundryMessages;
  isLateStorageFees?: boolean;
}

const Collections: React.FunctionComponent<CollectionsProps> = ({
  closeTransportModal,
  bookCollectionsOnClickHandler,
  location,
  sundryMessages,
  isLateStorageFees = false,
}) => {
  const {
    data: { isToUseAuthZero, authZeroAccessToken },
  } = useAuthZeroContext();

  const [collectionAddress, setCollectionAddress] =
    useState<ICollectionAddress>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    getLocationService(location, isToUseAuthZero, authZeroAccessToken)
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
      })
      .then((response) => {
        setCollectionAddress({ ...response?.address });
        setIsLoading(false);
      });
  }, [location, isToUseAuthZero, authZeroAccessToken]);

  const collectionsClickHandler = () => {
    if (sundryMessages.collectionsAction) {
      closeTransportModal();
      sundryMessages.collectionsAction();

      return;
    }

    bookCollectionsOnClickHandler();
  };

  return (
    <DetailedCard
      width="100%"
      icon="key"
      link={sundryMessages.collectionsLink}
      headline="Collections"
      label={sundryMessages.collectionsCta}
      ariaLabel="Collections"
      showLinkAsButton={isLateStorageFees}
      iconColor="#1D2948"
      hoverBorderEnabled={false}
      additionalOnClickHandler={collectionsClickHandler}
    >
      <CollectionsContent
        isLoading={isLoading}
        locationName={location}
        collectionAddress={collectionAddress}
      />

      {isLateStorageFees && <OutstandingChargesMessage />}

      {sundryMessages.collectionsAlert && !isLateStorageFees && (
        <TransportAlert
          message={sundryMessages.collectionsAlert}
          weight="bold"
          mb={4}
        />
      )}
    </DetailedCard>
  );
};

export default Collections;
